import React from 'react';
import { Line } from 'components';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { hoursByDay } from 'utils';

export function GraphicLog(props) {
  const { data, loading } = props;
  const threshold = useSelector(
    ({
      customers: {
        data: {
          thresholds: { orp },
        },
      },
    }) => orp,
  );
  return (
    <Line
      loading={loading}
      data={data}
      thresholds={threshold}
      xAccessor="hour"
      yAccessor="value"
      colors={{ scheme: 'category10' }}
      axes={{
        left: {
          tickSize: 4,
          tickPadding: 5,
          tickRotation: 0,
          legend: I18n('ORP (mv)'),
          legendOffset: -40,
          legendPosition: 'middle',
        },
        bottom: {
          tickSize: 10,
          tickValues: hoursByDay(60),
          tickRotation: 90,
          legend: I18n('hour', true),
          legendOffset: 55,
          legendPosition: 'middle',
        },
      }}
    />
  );
}
